import { AnimatePresence, motion } from 'framer-motion';
import type { TimePeriod } from './timeOfDayConfig.js';
import MorningCloudMascot from './MorningCloudMascot.js';
import DefaultCloudMascot from './DefaultCloudMascot.js';
import HomeV2CloudMascot from './HomeV2CloudMascot.js';
import NightCloudMascot from './NightCloudMascot.js';
import NightZs from './NightZs.js';
import { useMemo } from 'react';

interface TimeOfDayMascotProps {
  period: TimePeriod;
  size: number;
  className?: string;
}

const mascotMap: Record<TimePeriod, React.ComponentType<{ size?: number; className?: string }>> = {
  night: NightCloudMascot,
  dawn: MorningCloudMascot,
  midday: DefaultCloudMascot,
  afternoon: DefaultCloudMascot,
  sunset: HomeV2CloudMascot,
};

/**
 * Renders the correct cloud mascot for the given time period
 * with crossfade animation on period change.
 */
export default function TimeOfDayMascot({ period, size, className }: TimeOfDayMascotProps) {

  const MascotComponent = useMemo(() => mascotMap[period], [period]);

  return (
    <div className={`relative ${className ?? ''}`}>
      <AnimatePresence mode="wait">
        <motion.div
          key={period}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <MascotComponent size={size} />
        </motion.div>
      </AnimatePresence>

      {/* Night-only Zs decoration, positioned relative to mascot */}
      {period === 'night' && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <NightZs />
        </motion.div>
      )}
    </div>
  );
}
